import { Box, Button, FormControl, IconButton, MenuItem, Select, Stack } from '@mui/material';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

import { SpacesOrderBy } from '../../stores/mainStore';

type MainContentHeaderProps = {
  sectionTitle: string;
  canOpenWorkspaceMenu: boolean;
  showOrderBy?: boolean;
  memberCount: number | null;
  onWorkspaceMembersOpen: () => void;
  orderBy: SpacesOrderBy;
  onOrderByChange: (value: SpacesOrderBy) => void;
  onWorkspaceMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
};

export const MainContentHeader = ({
  canOpenWorkspaceMenu,
  showOrderBy = true,
  memberCount,
  onWorkspaceMembersOpen,
  orderBy,
  onOrderByChange,
  onWorkspaceMenuOpen,
}: MainContentHeaderProps) => {
  return (
    <>
      <Stack spacing={1}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems={{ md: 'center' }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            {memberCount !== null && (
              <Button
                variant="text"
                startIcon={
                  <Box
                    component="img"
                    src="https://storage.googleapis.com/dotstorming-img/participants.svg"
                  />
                }
                onClick={onWorkspaceMembersOpen}
                sx={{ color: '#596273', fontWeight: 700, fontSize: 18, textTransform: 'none' }}
              >
                {memberCount}
              </Button>
            )}
          </Stack>
          {(showOrderBy || canOpenWorkspaceMenu) && (
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
              {showOrderBy && (
                <FormControl size="small" sx={{ minWidth: 300 }}>
                  <Select
                    labelId="order-by-label"
                    value={orderBy}
                    onChange={(event) => onOrderByChange(event.target.value as SpacesOrderBy)}
                  >
                    <MenuItem value="title">Order spaces by name</MenuItem>
                    <MenuItem value="created">Order spaces by created</MenuItem>
                  </Select>
                </FormControl>
              )}
              {canOpenWorkspaceMenu && (
                <IconButton size="small" onClick={onWorkspaceMenuOpen}>
                  <MoreVertOutlinedIcon fontSize="small" />
                </IconButton>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
    </>
  );
};
